import React from 'react';
import Icon from '../../../components/AppIcon';


const AgentCard = ({ agent, isActive, isCompleted, isLocked, onClick }) => {
  const getStatusColor = () => {
    if (isCompleted) return 'bg-success/10 border-success';
    if (isActive) return 'bg-primary/10 border-primary';
    if (isLocked) return 'bg-muted border-border opacity-60';
    return 'bg-card border-border hover:border-primary/50';
  };

  const getIconColor = () => {
    if (isCompleted) return 'var(--color-success)';
    if (isActive) return 'var(--color-primary)';
    if (isLocked) return 'var(--color-muted-foreground)';
    return 'var(--color-foreground)';
  };

  return (
    <button
      onClick={onClick}
      disabled={isLocked}
      className={`w-full p-4 rounded-lg border-2 transition-all duration-200 ${getStatusColor()} ${
        isLocked ? 'cursor-not-allowed' : 'cursor-pointer'
      }`}
    >
      <div className="flex items-start space-x-3">
        <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${
          isCompleted ? 'bg-success/20' : isActive ? 'bg-primary/20' : 'bg-muted'
        }`}>
          {isCompleted ? (
            <Icon name="CheckCircle" size={24} color="var(--color-success)" />
          ) : (
            <Icon name={agent?.icon} size={24} color={getIconColor()} />
          )}
        </div>

        <div className="flex-1 text-left min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className={`text-sm font-heading font-semibold ${
              isActive ? 'text-primary' : 'text-foreground'
            }`}>
              {agent?.name}
            </h3>
            {isLocked && (
              <Icon name="Lock" size={16} className="text-muted-foreground" />
            )}
          </div>
          <p className="text-xs text-muted-foreground line-clamp-2">
            {agent?.description}
          </p>
        </div>
      </div>
    </button>
  );
};

export default AgentCard;